import { Dialog } from '@material-ui/core';
import styled from 'styled-components';

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paperWidthSm {
    width: 100%;
    display: flex;
    position: relative;
    max-width: 650px;
  }
  .success-close-icon {
    position: absolute;
    right: 15px;
    top: 15px;
  }

  .success-title {
    font-size: 14px;
    font-weight: 400;
    color: #172c51;
    line-height: 16.7px;
  }

  .success-actions {
    position: relative;
    padding: 5px;
    display: flex;
    flex-direction: row;
  }
  .success-actions > button {
    margin: 5px;
  }

  #secondary-button-style {
    margin: 20px 0;
    padding: 10px;
    color: #0075c9;
  }
  .primary-button {
    padding-left: 5px;
    color: #ffffff !important;
    border-color: #0075c9;
    background-color: #0075c9;
    &:hover {
      background-color: #0075c9;
      border: 1px solid #0075c9;
    }
    &:mui-disabled {
      color: #ffffff;
    }
  }

  .ChevronRightIcon {
    margin-left: 10px;
    fill: white;
  }
`;
